import { type FC, type HTMLAttributes, type ReactNode } from 'react'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import * as styles from './styles'

export type SheetBodyProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
  title?: string
}

const SheetBody: FC<SheetBodyProps> = ({ children, title }) => {
  const theme = useTheme()

  return (
    <div ref={(node) => node?.focus()} css={styles.body(theme)}>
      {title && (
        <Typography css={styles.title(theme)} component="h1" variant="h3">
          {title}
        </Typography>
      )}
      {children}
    </div>
  )
}

export default SheetBody
